import { AfterViewInit, Component, effect, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { NotificationsService } from './notifications.service';
import { InlineDialogComponent } from 'app/shared/dialog/inline-dialog/inline-dialog.component';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { IconComponent } from 'app/shared/icon/icon.component';
import { NotificationEnum } from './model/notifications.model';
import { ButtonComponent } from 'app/shared/button/button.component';

@Component({
  selector: 'app-notifications',
  imports: [InlineDialogComponent, MatTabGroup, MatTab, MatTabLabel, IconComponent, ButtonComponent],
  standalone: true,
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements AfterViewInit {
  @ViewChild('loadMore') set loadMoreEl(el: ElementRef | undefined) {
    if (el) {
      this.observer.observe(el.nativeElement);
    } else {
      this.observer?.disconnect();
    }
  }

  private observer!: IntersectionObserver;
  private service = inject(NotificationsService);
  NotificationEnum = NotificationEnum;

  notifications = this.service.notifications;
  open = this.service.dialogOpened;
  preHandled = this.service.preHandled;
  selectedTab = this.service.selectedTab;

  constructor() {
    effect(() => {
      this.service.getNotifications({ handleable: !!this.service.selectedTab() });
    });
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !this.service.isLoading() && !this.service.isLast()) {
        this.service.getNotifications({
          handleable: !!this.service.selectedTab(),
          skip: this.service.notificationLength(),
        });
      }
    });
  }

  onTabIndexChange(tab: NotificationEnum) {
    this.service.selectedTab.set(tab);
    this.service.isLast.set(false);
  }

  share(friendId: number, notificationId: string) {
    this.service.shareTo(friendId, notificationId);
  }

  delete(friendId: number, notificationId: string) {
    this.service.delete(friendId, notificationId);
  }

  approve(commentId: string, notificationId: string) {
    this.service.approve(commentId, notificationId);
  }

  reject(commentId: string, notificationId: string) {
    this.service.reject(commentId, notificationId);
  }
}
